import React from 'react';
import { Link } from 'react-router-dom';
import { useLanguage } from '../context/LanguageContext';

const Header = ({ cartItemCount, setShowCart, onSearchClick, onMenuClick }) => {
    const LOGO_URL = "/logo-optimized.webp";
    const { t, toggleLanguage } = useLanguage();

    return (
        <header className="bg-white py-4 border-b border-gray-100">
            <div className="container mx-auto px-4 sm:px-6 lg:px-8">
                <div className="flex justify-between items-center relative">
                    
                    {/* Left: Menu & Search */}
                    <div className="flex-1 flex justify-start items-center gap-2 sm:gap-4">
                        <button onClick={onMenuClick} className="text-gray-800 hover:text-[#8B6939] transition-colors p-2" aria-label="Menu">
                             <svg xmlns="http://www.w3.org/2000/svg" className="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.5} d="M4 6h16M4 12h16M4 18h16" />
                            </svg>
                        </button>
                        <button onClick={onSearchClick} className="text-gray-800 hover:text-[#8B6939] transition-colors p-2" aria-label="Search">
                            <svg xmlns="http://www.w3.org/2000/svg" className="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.5} d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z" />
                            </svg>
                        </button>
                    </div>

                    {/* Center: Main Logo (Image) */}
                    <div className="flex-1 flex justify-center">
                        <Link to="/" className="flex items-center">
                            <img
                                decoding="async"
                                src={LOGO_URL} 
                                alt="Ukiyo" 
                                width="126"
                                height="80"
                                className="h-16 md:h-20 w-auto object-contain"
                            />
                        </Link>
                    </div>

                    {/* Right: Language Switcher & Cart */}
                    <div className="flex-1 flex justify-end items-center gap-2 sm:gap-3">
                        <button
                            type="button"
                            onClick={toggleLanguage}
                            aria-label="Switch Language"
                            className="px-2.5 py-1 text-xs sm:text-sm font-semibold text-[#8B6939] border border-[#b08d57]/50 rounded-full hover:bg-[#b08d57] hover:text-white transition-colors"
                        >
                            {t('switchLangLabel')}
                        </button>

                        <button 
                            onClick={() => setShowCart(true)} 
                            className="text-gray-800 hover:text-[#8B6939] transition-colors p-2 relative group"
                            aria-label="Cart"
                        >
                            <svg xmlns="http://www.w3.org/2000/svg" className="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.5} d="M16 11V7a4 4 0 00-8 0v4M5 9h14l1 12H4L5 9z" />
                            </svg>
                            {cartItemCount > 0 && (
                                <span className="absolute top-0 right-0 inline-flex items-center justify-center px-1.5 py-0.5 text-xs font-bold leading-none text-white transform translate-x-1/4 -translate-y-1/4 bg-[#b08d57] rounded-full">
                                    {cartItemCount}
                                </span>
                            )}
                        </button>
                    </div>
                </div>
            </div>
        </header>
    );
};

export default Header;
